module.exports = __webpack_public_path__ + "img/logo-mobile.8fdd25f3.png";